import { buttonClasses } from '@mui/material/Button'
import { Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const useStyles = makeStyles((theme: Theme) => ({
    appBar: {
        backgroundColor: theme.palette.background.default,
        position: 'relative',
    },
    headerContainer: {
        margin: 0,
        padding: theme.spacing(2),
        maxWidth: 'none',
    },
}))

export const SignUpStyles: moduleStyleType = {
    signUpButton: {
        maxHeight: 'none',
        [`&.${buttonClasses.root}`]: {
            py: 2,
        },
    },

}
